import { ToggleGroup, ToggleGroupItem } from '@mint-lib/tw-components';

import { Separator } from './Separator.jsx';
import { useToolbarState } from './useToolbarState.js';

type ToggleButtonsProps = {
  values: string[];
  /** Selection used while the query parameter is absent from the URL. */
  defaultValue?: string;
  separator?: boolean;
  /**
   * The selected toggle value is stored in this URL query parameter. Read the
   * value back from the route's search params; there is no change callback.
   *
   * This allows the toolbar state to be bookmarked and restored from the URL.
   *
   * @example
   * // ?view=Week restores the "Week" toggle
   * <ToggleButtons values={['Day', 'Week']} queryParamKey="view" />
   */
  queryParamKey: string;
};

export function ToggleButtons({
  values,
  defaultValue,
  separator,
  queryParamKey,
}: Readonly<ToggleButtonsProps>) {
  const [selected, setSelected] = useToolbarState<string>(
    defaultValue ?? '',
    queryParamKey,
  );

  return (
    <>
      <ToggleGroup type="single" value={selected} onValueChange={setSelected}>
        {values.map((value) => (
          <ToggleGroupItem key={value} value={value}>
            {value}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
      {separator && <Separator />}
    </>
  );
}
